// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1cDSk","footer":"ModalUpdate_footer__2iiuC"};